import { render } from "./CopyIntegrationModal.vue?vue&type=template&id=18bbbae0"
import script from "./CopyIntegrationModal.vue?vue&type=script&lang=js"
export * from "./CopyIntegrationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__